import { CRUD_CREATE_FAILURE, CRUD_UPDATE_FAILURE } from "react-admin"
import {stopSubmit} from 'redux-form'
import {put, takeEvery} from "redux-saga/effects"
import { showNotification } from 'react-admin'

export default function* errorSagas() {
    yield takeEvery([CRUD_CREATE_FAILURE, CRUD_UPDATE_FAILURE], crudCreateFailure)
}

export function* crudCreateFailure(action) {
    var fields = action.payload
    var errorObject = {}
    var notification = 'Error de validación'

    if(fields){
        for (let fieldName in fields) {
            errorObject[fieldName] = fields[fieldName]
        }
    }else{
        notification = 'Error de conexión'
    }

    yield put(showNotification(notification, 'warning'))
    yield put(stopSubmit('record-form', errorObject))
}
